<template>
	<header class="position-relative">
		<nav class="navbar navbar-expand-lg navbar-light fixed-top px-1 pb-0 px-lg-2" id="navbar">
			<div class="container bg-light rounded-3">
				<a class="navbar-brand order-lg-1 text-center" href="/">
					<h2 class="style_bold mb-0 notranslate" style="line-height: 1.6rem;"><span
							class="text-primary">o</span>ecca
					</h2>
					<p class="style_font_size_small style_bold mb-0 notranslate">BENIN</p>
				</a>



				<div class="d-flex align-items-center gap-2 order-lg-3">
					<!-- Notification button -->
					<template v-if="formationsActives.length > 0">
						<a class="nav-notification btn btn-light mb-0 text-warning" role="button"
							data-bs-toggle="dropdown" aria-expanded="true" data-bs-auto-close="outside">
							<i class="bi bi-bell fa-fw"></i>
						</a>

						<div class="dropdown-menu dropdown-animation dropdown-menu-end dropdown-menu-size-md shadow-lg p-0"
							data-bs-popper="static">
							<div class="card bg-transparent">
								<div
									class="card-header bg-transparent d-flex justify-content-between align-items-center border-bottom">
									<h6 class="m-0">Notifications <span
											class="badge bg-danger bg-opacity-10 text-danger ms-2">{{
												formationsActives.length }} new</span></h6>
									<router-link class="small" to="formation-list">Voir Plus</router-link>
								</div>

								<div class="card-body p-0">
									<ul class="list-group list-group-flush list-unstyled p-2"
										v-for="formation in formationsActives" :key="formation.id">
										<li>
											<router-link
												:to="{ name: 'detail-formation', params: { id: formation?.code } }"
												class="list-group-item list-group-item-action rounded notif-unread border-0 mb-1 p-3">
												<h6 class="mb-1 text-truncate" style="font-size: 14px;">{{
													formation.title }}</h6>
												<p class="mb-0 small text-truncate"
													style="font-size: 12px; max-width: 300px;">{{ formation.summary }}
												</p>
											</router-link>
										</li>

									</ul>
								</div>
							</div>
						</div>
					</template>


					<div v-if="user" class="dropdown py-2">
						<a href="#"
							class="nav-link dropdown-toggle style_font_size_small style_medium d-flex align-items-center style_after_none"
							role="button" data-bs-toggle="dropdown" aria-expanded="false">
							<div class="style_bg_img rounded-circle border bg-light" style="width: 35px; height: 35px;">
								<div class="d-flex justify-content-center align-items-center rounded-circle p-2 w-100 h-100"
									style="background-color: rgba(0, 0, 0, 0.);">
									<i class="bi-person"></i>
								</div>
							</div>
						</a>
						<ul class="dropdown-menu dropdown-menu-end p-3 border-0 shadow"
							style="min-width: 18rem; max-height: 30rem; overflow-y: auto; -ms-overflow-style: none;   overflow: -moz-scrollbars-none;">
							<a href="#" class="">
								<h6 class="mb-0 style_bold">{{ user?.nom }} {{ user?.prenoms }}</h6>
								<small>{{ user?.email }}</small>
							</a>
							<hr>
							<div class="list-group p-0">
								<router-link to="/admin"
									class="rounded-2 list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center">
									<span><i class="bi-window me-2"></i>Mon Espace</span>
								</router-link>
								<a @click="handleLogout"
									class="rounded-2 list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center">
									<span><i class="bi-power me-2"></i>Déconnexion</span>
								</a>
							</div>
						</ul>
					</div>

					<router-link v-else to="/auth" class="btn btn-primary text-nowrap style_gradient" type="button"><i
							class="bi bi-box-arrow-in-right me-2"></i>Se
						connecter</router-link>

					<button class="navbar-toggle border-0 d-lg-none border-0 bg-transparent" type="button"
						@click="toggleMenu">
						<span class="navbar-toggler-icon"></span>
					</button>
				</div>

				<div class="collapse navbar-collapse flex-grow-0 order-lg-2 w-100" id="navbarSupportedContent"
					:class="{ 'show': isMenuOpen }">
					<ul class="navbar-nav mx-auto gap-2">
						<li class="nav-item">
							<a href="/" class="nav-link active">Accueil</a>
						</li>

						<li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle d-flex align-items-center gap-1" href="#" role="button"
								data-bs-toggle="dropdown" aria-expanded="false">
								<span>L'Ordre</span>
							</a>
							<ul class="dropdown-menu py-0">
								<li>
									<router-link to="/presentation-missions" class="dropdown-item">
										Présentation et missions
									</router-link>
								</li>
								<li>
									<router-link to="/mot-du-president" class="dropdown-item">
										Mot du Président
									</router-link>
								</li>
								<li>
									<router-link to="#" class="dropdown-item">
										Orientations Stratégiques
									</router-link>
								</li>

								<!-- Dropdown imbriqué pour "Gouvernance" -->
								<li class="dropdown-submenu">
									<a class="dropdown-item dropdown-toggle" href="#">
										Gouvernance
									</a>
									<ul class="dropdown-menu">
										<li>
											<router-link to="/conseil-ordre" class="dropdown-item">
												Conseil de l'Ordre
											</router-link>
										</li>
										<li>
											<router-link to="/comites" class="dropdown-item">
												Commissions & Comités
											</router-link>
										</li>
										<li>
											<router-link to="/assemble-general" class="dropdown-item">
												Assemblée Générale
											</router-link>
										</li>
									</ul>
								</li>

								<li>
									<router-link to="/texte-fondamentaux" class="dropdown-item">
										Textes fondamentaux et réglementaires
									</router-link>
								</li>
								<li>
									<router-link to="/rapport-activites" class="dropdown-item">
										Rapports d'activités
									</router-link>
								</li>
							</ul>
						</li>


						<li class="nav-item">
							<a class="nav-link dropdown-toggle d-flex align-items-center gap-1" href="#" role="button"
								data-bs-toggle="dropdown" aria-expanded="false">
								<span>Membres</span>
							</a>
							<div class="style_sous_menu border p-3 bg-white container rounded-lg animated">
								<div class="row">
									<div class="col-sm mb-3">
										<div class="px-3">
											<h6 class="text-primary">Tableau de l'Ordre</h6>
											<div class="col">
												<ul class="list-group list-group-flush bg-transparent text-white">
													<router-link to="/personnes-physiques"
														class="list-group-item naviguation">Experts-comptables
														(personnes physiques)</router-link>
													<router-link to="/cga"
														class="list-group-item naviguation">Sociétés d'expertise
														comptable, Centres de gestion
														agréés</router-link>
													<router-link to="/services/decisions-de-justice"
														class="list-group-item naviguation">Comptables
														agréés</router-link>
													<router-link to="/services/decisions-de-justice"
														class="list-group-item naviguation">Experts-comptables
														stagiaires
													</router-link>
													<a @click="openModal" class="list-group-item naviguation">Rechercher
														un
														professionnel</a>
												</ul>
											</div>
										</div>
									</div>
									<div class="col-sm mb-3">
										<div class="px-3">
											<h6 class="text-primary">Devenir membre</h6>
											<div class="col">
												<ul class="list-group list-group-flush bg-transparent text-white">
													<router-link to="/email-validation"
														class="list-group-item naviguation">Formulaire
														d'Inscription
													</router-link>
													<router-link to="/suivre-demande"
														class="list-group-item naviguation">Suivi de
														demande</router-link>
													<router-link to="/modele-docmument"
														class="list-group-item naviguation">Modèles de
														documents</router-link>
													<router-link to="/condition-inscription"
														class="list-group-item naviguation">Conditions
														d'inscription</router-link>
													<router-link to="/procedure"
														class="list-group-item naviguation">Procédure
														d'admission</router-link>
													<router-link to="/services/demarches-administratives"
														class="list-group-item naviguation">FAQ
														inscription</router-link>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</li>

						<!-- <li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle d-flex align-items-center gap-1" href="#" role="button"
								data-bs-toggle="dropdown" aria-expanded="false">
								<span>Profession</span>
							</a>
							<ul class="dropdown-menu py-0">
								<li>
									<router-link to="/email-validation" class="dropdown-item">
										Déontologie et éthique
									</router-link>
								</li>
								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Normes professionnelles
									</router-link>
								</li>

								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Domaines d'intervention
									</router-link>
								</li>

								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Contrôle qualité
									</router-link>
								</li>

								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Lutte anti-blanchiment
									</router-link>
								</li>

								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Responsabilité professionnelle
									</router-link>
								</li>

								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Honoraires
									</router-link>
								</li>
							</ul>
						</li> -->

						<!-- <li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle d-flex align-items-center gap-1" href="#" role="button"
								data-bs-toggle="dropdown" aria-expanded="false">
								<span>Services</span>
							</a>
							<ul class="dropdown-menu py-0">
								<li>
									<router-link to="/formation-list" class="dropdown-item">
										Formation continue
									</router-link>
								</li>
								 <li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Ressources professionnelles
									</router-link>
								</li>

								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Outils et guides pratiques
									</router-link>
								</li>

								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Modèles de documents
									</router-link>
								</li>

								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Assistance technique
									</router-link>
								</li>

								<li>
									<router-link to="/suivre-demande" class="dropdown-item">
										Cotisations
									</router-link>
								</li> 
							</ul>
						</li> -->

						<!-- <li class="nav-item">
							<a class="nav-link dropdown-toggle d-flex align-items-center gap-1" href="#" role="button"
								data-bs-toggle="dropdown" aria-expanded="false">
								<span>Actualités</span>
							</a>
							<div class="style_sous_menu border p-3 bg-white container rounded-lg animated">
								<div class="row">
									<div class="col-sm mb-3">
										<div class="px-3">
											<h6 class="text-primary">Actualités & événements</h6>
											<div class="col">
												<ul class="list-group list-group-flush bg-transparent text-white">
													<router-link to="/actualites"
														class="list-group-item naviguation">Actualités de la
														profession</router-link>
													<router-link to="/agenda" class="list-group-item naviguation">Agenda
														des événements</router-link>
													<router-link to="/newsletters"
														class="list-group-item naviguation">Newsletters</router-link>
													<router-link to="/communiques"
														class="list-group-item naviguation">Communiqués</router-link>

												</ul>
											</div>
										</div>
									</div>

									<div class="col-sm mb-3">
										<div class="px-3">
											<h6 class="text-primary">Documentation</h6>
											<div class="col">
												<ul class="list-group list-group-flush bg-transparent text-white">
													<router-link to="/publications"
														class="list-group-item naviguation">Publications</router-link>
													<router-link to="/textes-legislatifs"
														class="list-group-item naviguation">Etudes et
														rapports</router-link>
													<router-link to="/textes-legislatifs"
														class="list-group-item naviguation">Textes
														législatifs et réglementaires</router-link>
													<router-link to="/doctrine"
														class="list-group-item naviguation">Doctrine
														professionnelle</router-link>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</li> -->

						<li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle d-flex align-items-center gap-1" href="#" role="button"
								data-bs-toggle="dropdown" aria-expanded="false">
								<span>Contact</span>
							</a>
							<ul class="dropdown-menu py-0">
								<li>
									<router-link to="/contact" class="dropdown-item">
										Contact & Coordonnées
									</router-link>
								</li>

								<li>
									<router-link to="/anuaire" class="dropdown-item">
										Annuaire des services
									</router-link>
								</li>

							</ul>
						</li>

						<li class="nav-item">
							<div id="google_translate_element" style="display: none;"></div>

						</li>


						<li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle d-flex align-items-center gap-1" href="#" role="button"
								data-bs-toggle="dropdown" aria-expanded="false">
								<img :src="selectedLang.flag" class="img-fluid" :alt="selectedLang.code">
								<span>{{ selectedLang.name }}</span>
							</a>
							<ul class="dropdown-menu py-0">
								<li>
									<a @click.prevent="changeLanguage('fr')"
										class="dropdown-item d-flex align-items-center gap-1" href="#">
										<img src="@/assets/img/flag/fr.svg" class="img-fluid" alt="fr">
										<span>Français</span>
									</a>
								</li>
								<li>
									<a @click.prevent="changeLanguage('en')"
										class="dropdown-item d-flex align-items-center gap-1" href="#">
										<img src="@/assets/img/flag/en.svg" class="img-fluid" alt="en">
										<span>English</span>
									</a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</nav>


		<div class="modal fade" id="searchModal" data-bs-backdrop="static" tabindex="-1"
			aria-labelledby="exampleModalInitialisationLabel" aria-hidden="true" style="backdrop-filter: blur(10px);">
			<div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content border-0">
					<div class="modal-header border-0 pb-0 align-items-start">
						<h5 class="mb-0" id="exampleModalInitialisationLabel"></h5>
						<button type="button" class="btn-close ms-md-5" data-bs-dismiss="modal"
							aria-label="Close"></button>
					</div>
					<div class="modal-body text-center">
						<!-- Barre de recherche -->
						<div class="input-group mb-5">
							<input type="text" class="form-control form-control-lg"
								placeholder="Rechercher un professionnel de l'emploi..." v-model="rechercheTexte"
								@keyup.enter="close">
							<button class="btn btn-primary" @click="close">
								<i class="bi-search"></i>
							</button>
						</div>
						<!-- Légende -->
						<p class="text-muted"></p>
						<!-- Image -->
						<img src="../../assets/img/image.png" alt="Recherche" width="120">
					</div>
				</div>
			</div>
		</div>

	</header>

</template>

<script>
export default {
	data() {
		return {
			isScrolled: false, formationsActives: [], isMenuOpen: false, rechercheTexte: '',
			selectedLang: {
				code: 'fr',
				name: 'Français',
				flag: require('@/assets/img/flag/fr.svg')
			}
		};
	},
	computed: {
		user() {
			const user = JSON.parse(localStorage.getItem('user'));
			if (user && this.checkTokenValidity()) {
				return user;
			} else {
				localStorage.removeItem('user'); // Optionnel : nettoyer le localStorage
				return null;
			}
		}
	},
	methods: {
		toggleMenu() {
			this.isMenuOpen = !this.isMenuOpen
		},
		handleScroll() {
			this.isScrolled = window.scrollY > 1;
		},
		async listFormation() {
			try {
				const response = await this.$store.dispatch('formation/getAllP');
				const today = new Date();

				const reponse = response.data.content;
				this.formationsActives = reponse.filter(f =>
					f.dateDeb && f.dateFin && new Date(f.dateFin) >= today
				);
			} catch (error) {
				console.error('Erreur lors de la récupération des formations :', error);
			}
		},
		openModal() {
			// Déplacer le modal 
			document.body.appendChild(document.getElementById('searchModal'));

			// Ouvrir le modal
			const modal = new bootstrap.Modal(document.getElementById('searchModal'));
			modal.show();
		},
		close() {
			// Récupérer le modal
			const modalElement = document.getElementById('searchModal');

			// Créer un gestionnaire d'événements pour l'événement "hidden.bs.modal"
			const hiddenHandler = () => {
				// Masquer manuellement le backdrop
				const backdrop = document.querySelector('.modal-backdrop');
				if (backdrop) {
					backdrop.style.display = 'none';
				}
			};

			// Ajouter l'événement "hidden.bs.modal"
			modalElement.addEventListener('hidden.bs.modal', hiddenHandler);

			// Fermer le modal
			const modal = bootstrap.Modal.getInstance(modalElement);
			modal.hide();

		},
		changeLanguage(lang) {
			const select = document.querySelector("select.goog-te-combo");
			if (select) {
				select.value = lang;
				select.dispatchEvent(new Event("change"));
			}

			// Met à jour l'affichage de la langue sélectionnée
			if (lang === 'fr') {
				this.selectedLang = {
					code: 'fr',
					name: 'Français',
					flag: require('@/assets/img/flag/fr.svg')
				};
			} else if (lang === 'en') {
				this.selectedLang = {
					code: 'en',
					name: 'English',
					flag: require('@/assets/img/flag/en.svg')
				};
			}

			// Sauvegarde dans le localStorage
			localStorage.setItem('selectedLang', lang);
		},
		checkTokenValidity() {
			const user = JSON.parse(localStorage.getItem("user"));
			if (!user || !user.token) return false;

			const token = user.token;
			const payload = JSON.parse(atob(token.split('.')[1]));

			const currentTime = Math.floor(Date.now() / 1000); // en secondes
			return payload.exp > currentTime;
		},
		async handleLogout() {
			try {
				this.$loading = true; // Active ton loader global s’il est bien configuré
				await this.$store.dispatch('connexion/logout');

				// Nettoyage manuel si besoin
				localStorage.removeItem('user');

				// Redirection vers la page de connexion
				this.$router.push('/auth');

				this.$toast.open({
					type: "success",
					message: "Déconnexion réussie!",
					position: "top-right",
				});
			} catch (error) {
				console.error('Erreur lors de la déconnexion :', error);
				this.toast.open({
					type: "error",
					message: "Erreur lors de la déconnexion.",
					position: "top-right",
				});
			} finally {
				this.$loading = false; // Stoppe le loader
			}
		}

	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);

		if (!document.getElementById('google-translate-script')) {
			const script = document.createElement('script');
			script.id = 'google-translate-script';
			script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
			document.head.appendChild(script);
		}

		window.googleTranslateElementInit = () => {
			new window.google.translate.TranslateElement({
				pageLanguage: 'fr',
				includedLanguages: 'fr,en',
				autoDisplay: false
			}, 'google_translate_element'); // on peut cacher cette div
		};

		const savedLang = localStorage.getItem('selectedLang') || 'fr';
		this.changeLanguage(savedLang);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	created() {
		this.listFormation();
	},
};

</script>

<style scoped>
/* Styles pour les sous-menus */
.dropdown-submenu {
	position: relative;
}

.dropdown-submenu .dropdown-menu {
	top: 0;
	left: 100%;
	margin-top: -6px;
	/* Ajuster pour aligner correctement */
	margin-left: -1px;
	
	/* Arrondir les coins */
	display: none;
	/* Masquer par défaut */
}

.dropdown-submenu:hover .dropdown-menu {
	display: block;
	/* Afficher le sous-menu au survol */
}


.list-group-item.naviguation:hover {
	color: blue !important;
	/* Remplace "black" par la couleur de ton choix */
}
</style>